import { getCachedDistance } from "../services/firebase";

// Calculate distance between two coordinates (using cached version)
export const calculateDistance = (lat1, lon1, lat2, lon2) => {
  return getCachedDistance([lon1, lat1], [lon2, lat2]);
};

// Utility function to convert coordinates from [lat, lng] to [lng, lat] for Mapbox
export const convertToMapboxFormat = (coordinates) => {
  if (!coordinates || !Array.isArray(coordinates) || coordinates.length !== 2) {
    return null;
  }
  // Convert from [lat, lng] to [lng, lat] for Mapbox
  return [coordinates[1], coordinates[0]];
};

// Ultra-fast BIB lookup function using new chunked data
export const getBibData = (bibNumber) => {
  // Import here to avoid circular dependencies
  const { findParticipantByBIB } = require("../wayfinder-data-index.js");
  return findParticipantByBIB(bibNumber);
};

// Helper function to calculate distance from a point to a line segment
export const calculateDistanceFromPointToLine = (px, py, x1, y1, x2, y2) => {
  const A = px - x1;
  const B = py - y1;
  const C = x2 - x1;
  const D = y2 - y1;

  const dot = A * C + B * D;
  const lenSq = C * C + D * D;

  let param = -1;
  if (lenSq !== 0) param = dot / lenSq;

  let xx, yy;

  if (param < 0) {
    xx = x1;
    yy = y1;
  } else if (param > 1) {
    xx = x2;
    yy = y2;
  } else {
    xx = x1 + param * C;
    yy = y1 + param * D;
  }

  const dx = px - xx;
  const dy = py - yy;

  // Return distance in kilometers
  return Math.sqrt(dx * dx + dy * dy) * 111; // Rough conversion to km
};

// Helper to compute projection parameter t (0..1) of point P onto line AB
export const computeProjectionParam = (px, py, x1, y1, x2, y2) => {
  const A = px - x1;
  const B = py - y1;
  const C = x2 - x1;
  const D = y2 - y1;
  const lenSq = C * C + D * D;
  if (lenSq === 0) return 0;
  const t = (A * C + B * D) / lenSq;
  if (t < 0) return 0;
  if (t > 1) return 1;
  return t;
};
